export class BackupAction {
  public Enabled: boolean;
  public CommandLine: string;
  public FullCommandLine: string;
  public Arguments: string;
  public Timeout: number;
  public IsRunning: boolean;
}
